(function(){
  function setMasterSelect(master, variantId){
    if(!master) return;
    var value=String(variantId);
    master.value=value;
    Array.prototype.forEach.call(master.options,function(option){ option.selected=option.value===value; });
  }

  function money(cents){
    if(window.theme&&theme.Currency&&theme.Currency.formatMoney){ return theme.Currency.formatMoney(cents, theme.moneyFormat); }
    var amount=(Number(cents||0)/100).toFixed(2);
    return '$'+amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function productFromSection(section){
    if(!section) return null;
    var id=section.getAttribute('data-section-id')||'product-template';
    var json=document.getElementById('ProductJson-'+id)||section.querySelector('[id^="ProductJson-"]');
    if(!json) return null;
    try{return JSON.parse(json.textContent||json.innerHTML);}catch(error){return null;}
  }

  function selectedVariant(section){
    var product=productFromSection(section);
    if(!product||!product.variants) return null;
    var selectors=section.querySelectorAll('.single-option-selector');
    if(!selectors.length) return null;
    for(var i=0;i<product.variants.length;i++){
      var variant=product.variants[i], ok=true;
      for(var index=0;index<selectors.length;index++){
        if(variant['option'+(index+1)]!==selectors[index].value){ ok=false; break; }
      }
      if(ok) return variant;
    }
    return null;
  }

  function sync(section){
    var variant=selectedVariant(section);
    if(!variant) return null;
    setMasterSelect(section.querySelector('select[name="id"][id^="ProductSelect-"]'), variant.id);
    var regular=section.querySelector('[data-regular-price]');
    if(regular) regular.innerHTML=money(variant.price);
    var sale=section.querySelector('[data-sale-price]');
    if(sale&&variant.compare_at_price&&variant.compare_at_price>variant.price) sale.innerHTML=money(variant.price);
    var sku=section.querySelector('.variant-sku');
    if(sku&&variant.sku) sku.innerHTML=variant.sku;
    return variant;
  }

  function patchThemeObjects(){
    if(window.slate&&slate.Variants&&slate.Variants.prototype){
      slate.Variants.prototype._updateMasterSelect=function(variant){
        setMasterSelect(document.querySelector(this.originalSelectorId), variant.id);
        setMasterSelect($(this.originalSelectorId,this.$container)[0], variant.id);
      };
    }
    if(window.theme&&theme.Product&&theme.Product.prototype){
      theme.Product.prototype._updateImages=function(evt){
        var variant=evt.variant;
        if(!variant||!variant.featured_image) return;
        var imageId=variant.featured_image.id;
        this._switchImage(imageId);
        this._setActiveThumbnail(imageId);
      };
    }
  }

  patchThemeObjects();
  document.addEventListener('DOMContentLoaded', patchThemeObjects);
  document.addEventListener('change',function(event){
    if(!event.target||!event.target.classList||!event.target.classList.contains('single-option-selector')) return;
    sync(event.target.closest('[data-section-id]'));
  },true);
  document.addEventListener('click',function(event){
    var button=event.target&&event.target.closest?event.target.closest('form[action*="/cart/add"] button,form[action*="/cart/add"] [type="submit"]'):null;
    if(!button) return;
    sync(button.closest('[data-section-id]'));
  },true);
  document.addEventListener('submit',function(event){
    var form=event.target;
    if(!form||!form.matches||!form.matches('form[action*="/cart/add"]')) return;
    sync(form.closest('[data-section-id]'));
  },true);
  window.GennaroVariantSync={sync:sync,selectedVariant:selectedVariant};
})();